<div class="title-container" fxLayout="row" fxLayoutGap="5pt" fxLayoutAlign="start center">
  <h1>
    {{ optionName }}
    <span class="page-title">{{ pageName }}</span>
  </h1>
  @if (image) {
    <img [src]="image" [height]="height" [width]="width" alt="Keyboard">
  }
</div>
